module.exports = __webpack_public_path__ + "assets/03ef0cd48efdd36a2e8fa123b8734eab.png";